import React from 'react';
import { Button, message, Upload, Modal } from 'antd'
import { app, api, config } from 'xadmin'
import { Icon } from 'xadmin-ui'
import _ from 'lodash'
export default class Uploading extends React.Component {
  constructor(props) {
    super(props);
    const { input: { value } } = this.props
    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList: value ? [ {
        uid: value,
        name: value,
        url: value,
      } ] : [],
      token: null
    }
  }

  componentDidMount() {
    this.setState({
      token: this.getCookie('token')
    },()=>{
      // console.log(this.state.token)
    })
  }

  handleCancel = () => this.setState({ previewVisible: false })

  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    });
  }

  handleChange = ({ fileList }) => {
    if (!fileList) return false
    const { input: { onChange } } = this.props
    const Errors = new Error('上传返回异常信息')
    this.setState({ fileList })
    const fileurl = fileList[0] && fileList[0].response && fileList[0].response.url
    fileurl ? onChange(config('mediaUrl') + fileurl) : Errors
  }

  getCookie = (cname) => {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for(let i=0; i<ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name)==0) { return c.substring(name.length,c.length); }
    }
    return '';
  }


  render() {
    const { input, label, meta, field } = this.props
    const { previewVisible, previewImage, fileList, token } = this.state;
  
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">上传图片</div>
      </div>
    )

    return (
      <div className="clearfix">
        <Upload
          action={api({ name: 'media' }).getHost() + `core/media/${field.category || 'img'}`}
          accept="image/*"
          listType="picture-card"
          fileList={fileList}
          headers={{
            Authorization: token,
            ..._.omit(api({ name: 'media' }).getHeaders(), 'Content-Type')
          }}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
        >
          {fileList.length >= 1 ? null : uploadButton}
        </Upload>
        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    )
  }
}
